import React from 'react';
import {Grid, makeStyles} from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import clsx from 'clsx';
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PlaylistAddRoundedIcon from '@material-ui/icons/PlaylistAddRounded';
import PlaylistAddCheckRoundedIcon from '@material-ui/icons/PlaylistAddCheckRounded';
import ProgressBar from "components/ProgressBar";
import PropTypes from "prop-types";
import Button from "components/Button";
import Tr from "translations/Translations";

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(4)
    },

    summary: {
        margin: theme.spacing(0),
        padding: theme.spacing(0),
    },
    summaryContent: {
        margin: theme.spacing(0) + " !important",
    },
    summaryButton: {
        margin: theme.spacing(0),
    },
    summaryGrid: {
        cursor: 'auto',
        userSelect: 'text',
        padding: theme.spacing(1)
    },
    gridItemCommon: {
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
    },
    gridItemButton: {
        justifyContent: 'flex-end',
    },
    icon: {
        fontSize: '3rem',
    },
    iconWait: {
        color: theme.palette.common.error
    },
    iconWaitOptional: {
        color: theme.palette.common.info
    },
    iconFinish: {
        color: theme.palette.common.success
    },
}));

const ExpansionProgressPanel = (
    {
        iconWait,
        iconFinish,
        title,
        progress,
        queue,
        progressAtlText,
        showProgress = true,
        optional,
        buttonText,
        buttonDisabled,
        onButtonClick = () => {
        },
        details,
        actions,
        alwaysExpanded,
        expanded

    }) => {
        const classes = useStyles();

        const IconWait = iconWait || (optional ? PlaylistAddRoundedIcon : ErrorIcon);
        const IconFinish = iconFinish || (optional ? PlaylistAddCheckRoundedIcon : CheckCircleIcon);

        return (<>
            <div className={classes.root}>
                <Accordion defaultExpanded={alwaysExpanded} expanded={alwaysExpanded || expanded}>
                    <AccordionSummary
                        className={classes.summary}
                        classes={{content: classes.summaryContent, expanded: classes.summaryExpanded, expandIcon: classes.summaryButton}}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <Grid
                            container
                            className={classes.summaryGrid}
                            onClick={event => event.stopPropagation()}
                            onFocus={event => event.stopPropagation()}
                        >
                            <Grid
                                item
                                className={classes.gridItemCommon}
                            >
                                {(!progress || progress < 100) &&
                                <IconWait className={clsx(classes.icon, optional ? classes.iconWaitOptional : classes.iconWait)}/>}
                                {progress >= 100 && <IconFinish className={clsx(classes.icon, classes.iconFinish)}/>}
                            </Grid>

                            <Grid
                                item
                                xs
                                className={classes.gridItemCommon}>
                                <Typography variant='h5'>
                                    {title}{!optional && "*"}
                                </Typography>
                            </Grid>

                            {showProgress && !progressAtlText && progress != null && (!queue || queue === 0) &&
                            <Grid
                                item
                                xs={3}
                                className={classes.gridItemCommon}
                            >
                                <ProgressBar max={100} value={progress}/>
                            </Grid>
                            }

                            {showProgress && !progressAtlText && progress != null && !!queue && queue > 0 &&
                            <Grid
                                item
                                xs={3}
                                className={classes.gridItemCommon}
                            >
                                <Typography>{queue + ' ' + Tr('in_queue')}</Typography>
                            </Grid>
                            }

                            {showProgress && progressAtlText &&
                            <Grid
                                item
                                xs={3}
                                className={classes.gridItemCommon}
                            >
                                <Typography>{progressAtlText}</Typography>
                            </Grid>
                            }

                            {buttonText && <Grid
                                item
                                xs={3}
                                className={clsx(classes.gridItemCommon, classes.gridItemButton)}
                            >
                                <Button
                                    size='large'
                                    color={optional ? 'primary' : 'secondary'}
                                    disabled={buttonDisabled}
                                    onClick={onButtonClick}
                                >
                                    {buttonText}
                                </Button>
                            </Grid>}
                        </Grid>
                    </AccordionSummary>


                    {details && <>
                        <Divider/>
                        <AccordionDetails className={classes.details}>
                            {details}
                        </AccordionDetails>
                    </>}

                    {actions && <>
                        <Divider/>
                        <AccordionActions>
                            {actions}
                        </AccordionActions>
                    </>}
                </Accordion>
            </div>
        </>);
    }
;

ExpansionProgressPanel.propTypes = {
    iconWait: PropTypes.object,
    iconFinish: PropTypes.object,
    optional: PropTypes.bool,
    title: PropTypes.string,
    progress: PropTypes.number,
    queue: PropTypes.number,
    buttonText: PropTypes.string,
    buttonDisabled: PropTypes.bool,
    onButtonClick: PropTypes.func,
    details: PropTypes.object,
    actions: PropTypes.object
}

ExpansionProgressPanel.defaultProps = {}
export default ExpansionProgressPanel;